import { SystemModulesEnum } from '@/auth/interfaces/system-modules.enum';
import { useAuthStore } from '@/store/auth/auth.store';
import { useUserModulesStore } from '@/store/auth/user-modules.store';

const isSuperUser = (): boolean => {
  const user = useAuthStore.getState().user as any;
  return !!(user?.is_superuser || user?.is_staff);
};

export const hasSystemModule = (module: SystemModulesEnum): boolean => {
  if (isSuperUser()) return true;
  const userModules = useUserModulesStore.getState().modules;

  return userModules.includes(module);
};

export const hasAllSystemModules = (modules: SystemModulesEnum[]): boolean => {
  if (isSuperUser()) return true;
  const userModules = useUserModulesStore.getState().modules;

  return modules.every(module => userModules.includes(module));
};
